<div>
  <!-- Active/Purchased section (dark background) -->
  <div class="active-subs-section" *ngIf="foundMembership || foundSubscription">
    <div class="container py-3">
      <!--Sub Count-->
      <div
        *ngIf="maxSubs > 0"
        class="sub-count-banner bg-primary d-flex flex-lg-row flex-column justify-content-lg-between align-items-lg-center"
      >
        <p class="fw-bold text-white mb-0 d-flex align-items-center gap-1">
          <span class="font-size-20">You have selected {{ activeSubs }}</span>
          <span class="font-size-16">of {{ maxSubs }}</span>
        </p>
      </div>

      <!--Active memberships-->
      <div *ngIf="foundMembership">
        <h3 class="mt-4 font-size-20 text-white">Memberships</h3>
        <ng-container *ngFor="let product of purchasedProducts">
          <div *ngIf="product.ProductType == 1">
            <fgb-subscriptions-list-item-renewals [subscribedProduct]="product"></fgb-subscriptions-list-item-renewals>
          </div>
        </ng-container>
      </div>

      <!--Active subscriptions-->
      <div *ngIf="foundSubscription">
        <h3 class="mt-4 font-size-20 text-white">Subscriptions</h3>
        <ng-container *ngFor="let product of purchasedProducts">
          <div *ngIf="product.ProductType == 3">
            <fgb-subscriptions-list-item-subscribed [subscribedProduct]="product"></fgb-subscriptions-list-item-subscribed>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="container mt-3">
    <!--Sub Count (no purchased items yet)-->
    <div
      *ngIf="maxSubs > 0 && !foundMembership && !foundSubscription"
      class="sub-count-banner bg-primary d-flex flex-lg-row flex-column justify-content-lg-between align-items-lg-center"
    >
      <p class="fw-bold text-white mb-0 d-flex align-items-center gap-1">
        <span class="font-size-20">You have selected {{ activeSubs }}</span>
        <span class="font-size-16">of {{ maxSubs }}</span>
      </p>
    </div>

    <!--Available membership options-->
    <div *ngIf="membershipPortalProducts.length && !foundMembership">
      <h3 class="mt-4 font-size-20">Memberships</h3>
      <div class="row">
        <ng-container *ngFor="let membProduct of membershipPortalProducts">
          <div class="col-lg-4 col-12 sub-list-spacing">
            <fgb-subscriptions-list-item [portalProduct]="membProduct"></fgb-subscriptions-list-item>
          </div>
        </ng-container>
      </div>
    </div>

    <!--Available subscription options-->
    <div *ngIf="notPurchasedActiveSubs.length > 0">
      <h3 class="mt-4 font-size-20">Digital Products</h3>
      <div class="row">
        <ng-container *ngFor="let subProduct of notPurchasedActiveSubs">
          <div class="col-lg-4 col-12 sub-list-spacing">
            <fgb-subscriptions-list-item [portalProduct]="subProduct"></fgb-subscriptions-list-item>
          </div>
        </ng-container>
      </div>
    </div>

    <!--membership and subscription cart modal-->
    <div class="footer-sticky">
      <div class="footer-card my-3" *ngIf="items().length">
        <div class="card-body px-0">
          <div class="w-100 p-3 card shadow">
            <div class="d-flex justify-content-between">
              <h3 class="text-primary font-size-16 ps-2">your basket</h3>
              <h3 class="text-primary font-size-14 cancel-button-subs pe-lg-3 pe-2 cursor-pointer" (click)="clearSubsBasket()">
                Cancel
              </h3>
            </div>
            <div class="container mt-3">
              <div class="row">
                <div *ngFor="let item of items()" class="col-lg-2 col-4">
                  <div
                    class="sub-item rounded text-center mb-4"
                    [ngClass]="{
                      'bg-primary': item.productData.ProductType == 1,
                      'bg-secondary': item.productData.ProductType == 3,
                    }"
                  >
                    <img class="portal-product-img my-2" src="{{ item.productData.PrimaryImage | contentImage: '6' }}" />
                  </div>
                  <div
                    class="rounded-circle bg-white text-danger remove-product text-center shadow fw-bold border-0 cursor-pointer"
                    (click)="remove(item)"
                  >
                    x
                  </div>
                </div>
              </div>
              <hr />
              <div class="row mb-3">
                <div class="col-lg-9 col-6 text-lg-end font-size-14 py-2">
                  <span class="fw-bold">Total Amount: </span
                  ><span class="text-success"> {{ totalCost() / 100 | FortressCurrencyPipe }}</span>
                </div>
                <div class="col-lg-3 col-6 text-end">
                  <button
                    type="button"
                    class="btn btn-success fw-bold w-100 checkout-btn font-size-14"
                    (click)="proceedToCheckout()"
                  >
                    Checkout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--No new products or active products-->
    <ng-container *ngIf="allProducts == 0">
      <div>
        <img class="no-subs-image d-flex mx-auto" src="assets/images/placeholders/no-subscriptions.svg" />
        <h5 class="text-primary text-center mt-3 mb-0 fw-bold text-uppercase">SUBSCRIPTIONS</h5>
        <p class="text-info text-center font-size-14">Currently Unavailable</p>
      </div>
    </ng-container>
  </div>
</div>
